import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ACTION_LABEL = { create: "作成", update: "更新", delete: "削除" };
const ACTION_TONE = { create: "text-emerald-600", update: "text-blue-600", delete: "text-red-600" };
const TYPE_LABEL = {
  property: "物件", room: "部屋", tenant: "入居者", contract: "契約", invoice: "請求",
  payment: "入金", expense: "経費", loan: "ローン", repair: "修繕", vendor: "業者",
  document: "書類", user: "ユーザー", company: "会社",
};

export default function AuditLog() {
  const { user } = useAuth();
  const isAdmin = user?.role === "company_admin" || user?.role === "system_admin";
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAdmin) { setLoading(false); return; }
    api.get("/audit").then(({ data }) => setLogs(data)).catch(() => {}).finally(() => setLoading(false));
  }, [isAdmin]);

  if (!isAdmin) {
    return (
      <div className="animate-fade-in">
        <PageHeader title="監査ログ" />
        <div className="bg-white border border-border rounded-sm py-16 text-center text-muted-foreground">
          <ShieldAlert className="w-10 h-10 mx-auto mb-3 text-gray-300" />この画面へのアクセス権限がありません
        </div>
      </div>
    );
  }

  const fmt = (v) => { const d = new Date(v); return isNaN(d) ? v : d.toLocaleString("ja-JP"); };

  return (
    <div className="animate-fade-in">
      <PageHeader title="監査ログ" subtitle="重要操作の変更履歴" />
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>
      ) : (
        <div className="border border-border bg-white rounded-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-gray-50 border-b text-left text-xs uppercase tracking-wider text-muted-foreground">
                  <th className="px-4 py-3">操作日時</th><th className="px-4 py-3">操作者</th>
                  <th className="px-4 py-3">操作</th><th className="px-4 py-3">対象</th><th className="px-4 py-3">対象ID</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((l, i) => (
                  <tr key={l.id || i} className="border-b last:border-0 hover:bg-gray-50" data-testid={`audit-${i}`}>
                    <td className="px-4 py-3 text-muted-foreground whitespace-nowrap">{fmt(l.created_at)}</td>
                    <td className="px-4 py-3">{l.actor_name}</td>
                    <td className={`px-4 py-3 font-medium ${ACTION_TONE[l.action] || ""}`}>{ACTION_LABEL[l.action] || l.action}</td>
                    <td className="px-4 py-3">{TYPE_LABEL[l.target_type] || l.target_type}</td>
                    <td className="px-4 py-3 text-xs text-muted-foreground font-mono">{String(l.target_id || "").slice(0, 8)}</td>
                  </tr>
                ))}
                {logs.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-muted-foreground">ログがありません</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
